import { Injectable } from '@angular/core';

export class FAScoringModelFinancialView {
lFAScoringModelFinancialViewId: string;
lFAScoringModelFinancialId: number;
lFAFinancialCategoryId: number;
lFAScoringModelIndexId: number;
IsScored: number;
FinancialCategoryAlias: string;
FormatString: string;
FormulaString: string;
IsVisible : number;
DisplayOrder : number;
lFAScoringModelId : number;
FAScoringModel: string;
FAFinancialCategory: string;
lFAFinancialGroupId : number;
lFADataInputTypeId : number;
lFAScoreCardIndexMapId : number;
lFAScoreCardId : number;
lFAScoreIndexId : number;
Weight : number;
lFAScoreWeightIndexId : number;
SCIMDisplayOrder : number;
FAFinancialGroup: string;
OriginalValue: any;
AdjustedValue: any;
Score: number;
WeightedScore: number;
ScoreCardGroupInfo: string;
FAScoreCard: string;
FAScoreCardGroup: string;
ScoreIndex: string;
WeightIndex: string;
ScoreCardGroupFormula: string;
Formula: string;
  MappingTable: string;
  GroupFormulaIndex: string;
  GroupFormulaValue: number;
  ConversionRate: number;
  FromCurrency: string;
  ToCurrency: string;
  ExchangeRateDate: string;

}

export class APIParam {
  Param: string;
  sBaseYearPeriod: string;
  sBasePeriod: string;
  sTradingcounterparty: string;
  oFAScoringModelFinancialView: FAScoringModelFinancialView[];
  sValue: string;
}

export class QuantitativeGroup {
  GroupName: string;
}
